export default __webpack_public_path__ + "static/media/vip-4.21b991ce.webp";